export class Costo {
    idCosto: number;
    clave: string;
    valor: number;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/costo.ts